import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RequestCollabForm from '../components/RequestCollabForm';

// Route-based entry point (e.g. from the collabs home page or post-sign-in
// redirects). On the explore surfaces the form opens in RequestCollabModal
// instead, so the explore page keeps its scroll position.
const RequestCollabPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequestCollabForm
      campaign={location.state?.campaign ?? null}
      client={location.state?.client ?? null}
      requestedCollab={location.state?.requestedCollab ?? null}
      pitchType={location.state?.pitchType}
      onExit={() => navigate('/collabs')}
    />
  );
};

export default RequestCollabPage;
